import { render, staticRenderFns } from "./MdVideoPlayer.vue?vue&type=template&id=f570188a&scoped=true&"
import script from "./MdVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./MdVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./MdVideoPlayer.vue?vue&type=style&index=0&id=f570188a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f570188a",
  null
  
)

export default component.exports